export default __webpack_public_path__ + "static/media/MDV_C__0002_Layer-4.764e1b8c.png";